export const GRACE_CANCELLATIONS_PER_YEAR = 3;
export const LATE_CANCELLATION_THERAPIST_FEE = 500;

/**
 * Count grace cancellations for a client in a calendar year.
 * @param {Array<{ grace_cancellation?: boolean, attendance_date?: string }>} records
 * @param {number} year
 */
export function countGraceCancellationsForYear(records, year) {
  if (!Array.isArray(records)) {
    return 0;
  }

  return records.filter((record) => {
    if (!record.grace_cancellation || !record.attendance_date) {
      return false;
    }
    return new Date(record.attendance_date).getFullYear() === year;
  }).length;
}

/**
 * @param {number} usedCount
 * @param {boolean} isGraceChecked
 */
export function canApplyGraceCancellation(usedCount, isGraceChecked) {
  if (!isGraceChecked) {
    return { allowed: true, remaining: GRACE_CANCELLATIONS_PER_YEAR - usedCount };
  }

  if (usedCount >= GRACE_CANCELLATIONS_PER_YEAR) {
    return { allowed: false, remaining: 0 };
  }

  return {
    allowed: true,
    remaining: GRACE_CANCELLATIONS_PER_YEAR - usedCount - 1,
  };
}

export function getGraceCancellationHelperText(usedCount, isGraceChecked) {
  const total = GRACE_CANCELLATIONS_PER_YEAR;
  const displayUsed = isGraceChecked ? usedCount + 1 : usedCount;

  if (usedCount >= total && !isGraceChecked) {
    return `All ${total} grace cancellations used this year`;
  }

  return `${displayUsed} of ${total} grace cancellations used this year`;
}
